module.exports = __webpack_public_path__ + "static/media/shopping-bag.ec17bfc6.svg";